import { render, staticRenderFns } from "./AdvancedColumn.vue?vue&type=template&id=08b4d7b6&scoped=true"
import script from "./AdvancedColumn.vue?vue&type=script&lang=js"
export * from "./AdvancedColumn.vue?vue&type=script&lang=js"
import style0 from "./AdvancedColumn.vue?vue&type=style&index=0&id=08b4d7b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b4d7b6",
  null
  
)

export default component.exports